/** First plausible email address in free text (ui.modal body fallback). */
const EMAIL_RE = /[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/;

export const extractEmail = (text: string | undefined | null): string | undefined => {
  if (!text) return undefined;
  const match = text.match(EMAIL_RE);
  return match?.[0];
};

/** Loose client-side check before enabling Confirm on an editable email. */
export const isPlausibleEmail = (value: string): boolean =>
  EMAIL_RE.test(value.trim()) && !value.trim().includes(' ');
